import { EditProps } from "react-admin";
import { DefaultEdit } from "../../../lib/components";
import { CurrencyForm } from "./CurrencyForm";

const CurrencyEdit= (props:EditProps) => {
  return (
    <DefaultEdit {...props} mutationMode="pessimistic">
      <CurrencyForm isEdit={true} />
    </DefaultEdit>
  );
};

export { CurrencyEdit };
